import accountReducer from './Account';
import campaignReducer from './Campaign';
import configReducer from './Config';
import configurationReducer from './Configuration';
import coverageReducer from './Coverage';
import dashboardReducer from './Dashboard';
import fileReducer from './File';
import officeReducer from './Office';
import optionReducer from './Option';
import patientReducer from './Patient';
import professionalReducer from './Professional';
import statisticsReducer from './Statistics';
import turnsReducer from './Turns';
import userReducer from './User';
import videoconferenceReducer from './Videoconference';

const rootReducer = () => ({
    account: accountReducer,
    campaign: campaignReducer,
    config: configReducer,
    configuration: configurationReducer,
    coverage: coverageReducer,
    dashboard: dashboardReducer,
    file: fileReducer,
    office: officeReducer,
    option: optionReducer,
    patient: patientReducer,
    professional: professionalReducer,
    statistics: statisticsReducer,
    turns: turnsReducer,
    user: userReducer,
    videoconference: videoconferenceReducer
});

export default rootReducer;
